import React from "react";

const Contact = ({ handleOpenModal }) => {
  return <></>;
};

export default Contact;
